import { render } from "./InvitationView.vue?vue&type=template&id=39b662e1&scoped=true&ts=true"
import script from "./InvitationView.vue?vue&type=script&lang=ts"
export * from "./InvitationView.vue?vue&type=script&lang=ts"

import "./InvitationView.vue?vue&type=style&index=0&id=39b662e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b662e1"]])

export default __exports__